module.exports = global["$"] = require("-!/github/workspace/js/node_modules/expose-loader/index.js?jQuery!./jquery.js");